import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FaFacebook,
  FaGithub,
  FaGlobe,
  FaGooglePlus,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa";
import {
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBCard,
  MDBCardText,
  MDBCardLink,
  MDBCardBody,
  MDBCardImage,
  MDBBtn,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBProgress,
  MDBProgressBar,
  MDBListGroup,
  MDBListGroupItem,
} from "mdb-react-ui-kit";
import { FiCamera } from "react-icons/fi";
import "./Profile.css";
import noImage from "../../../src/img/profile-icon-9.png";
import { uploadfile } from "../../services/tasks/tasks";
import { updateSignup } from "../.././services/auth/auth";
import { getUserData } from "../.././services/auth/auth";
import { API_URL } from "../../services/config/endpoints";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  let navigate = useNavigate();
  const [myLocalStorageData, setMyLocalStorageData] = useState();
  const [userId, setUserId] = useState();
  const [photo, setPhoto] = useState();
  // console.log('data of the',photo)
  useEffect(() => {
    const data = localStorage.getItem("user");
    setMyLocalStorageData(JSON.parse(data));
  }, []);
  const handleClick = () => {
    navigate("/UserForm");
  };
  useEffect(() => {
    let id = localStorage.getItem("userId");
    setUserId(id);

    userAllData(id);
  }, []);
  const userAllData = (id) => {
    getUserData({ _id: id })
      .then((data) => {
        setPhoto(data.data?.allData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleImage = (e) => {
    console.log("value", e.target.files[0]);
    const formdata = new FormData();
    let image = e.target.files[0];
    formdata.append("myFile", image);
    uploadfile(formdata);
    let file = e.target.files[0].name;
    formdata.append("myFile", file);
    let id = userId;
    updateSignup({ profilePicture: file, _id: id });
  };

  return (
    <section>
      <MDBContainer className="py-5" id="profile__container">
        <MDBRow className="mdr">
          <MDBCol lg="4" className="mdb">
            <MDBCard
              className="mb-4 cardmaindiv"
              style={{ backgroundColor: "grey" }}
            >
              <MDBCardBody className="text-center">
                <div>
                  {photo?.profilePicture ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL_IMG}/${photo.profilePicture}`}
                      alt=""
                      className="image"
                    />
                  ) : (
                    <img src={noImage} alt="" className="image" />
                  )}
                  <label className="photo" for="file-upload">
                    <FiCamera />
                  </label>

                  <input
                    className="hid"
                    type="file"
                    id="file-upload"
                    onChange={handleImage}
                  ></input>
                </div>
                <p className="fw-bold mb-1">{myLocalStorageData?.name}</p>
                <p className=" mb-1">Full Stack Developer</p>
                <p className=" mb-1">Example@gmail.com</p>
                <p className=" mb-4">Maneri Payan , Swabi , 🇵🇰 </p>
                <div className="d-flex justify-content-center mb-2">
                  <MDBBtn className="fw-bold" onClick={handleClick}>
                    Edit Profile
                  </MDBBtn>
                  <MDBBtn outline className="ms-1 fw-bold">
                    Follow
                  </MDBBtn>
                </div>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          {/* Full Details Table */}
          <MDBCol lg="8">
            <MDBCard className="mb-4 card" style={{ backgroundColor: "grey" }}>
              <MDBCardBody>
                <MDBRow>
                  <MDBCol sm="3" className="fw-bold">
                    <MDBCardText>Full Name</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9" className="">
                    <MDBCardText className="">
                      {myLocalStorageData?.name}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3" className="fw-bold">
                    <MDBCardText>Email</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9" className="">
                    <MDBCardText className="">
                      {myLocalStorageData?.email}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3" className="fw-bold">
                    <MDBCardText>Phone</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="">
                      {myLocalStorageData?.phoneNumber}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3" className="fw-bold">
                    <MDBCardText>Address</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="">
                      Street 04 ,Gulshanabad ,Maneri Payan ,Swabi,🇵🇰{" "}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </section>
  );
}
